import React, { forwardRef }  from 'react';
// import { Colors } from '../../../constants';

const RadioButton = forwardRef((props, ref) => {
    // const [ focusBorderColor, setFocusBorderColor ] = useState(`#${Colors.primaryColor}`);

    // useEffect(() => {
    //     setFocusBorderColor(`#${Colors.disabledText}`);
    // },
    // []);

    // function radioOnChange (e) {
    //     let radio_buttons = document.getElementsByClassName('radio-input');
    //     if (radio_buttons) {
    //         for (let i = 0; i < radio_buttons.length; i++) {
    //             radio_buttons[i].style.backgroundColor = 'transparent';
    //         }
    //     }
    //     if (e.target.checked) {
    //         e.target.style.backgroundColor = props.color;
    //     }
    // }

    let text_default_value = props.URL_PARAMS.get(props.data['name'].toLowerCase()?.split(" ").join("_"));
    if(text_default_value !== null){
        text_default_value = text_default_value?.split("_").join(" ") || "";
    }

    let content=[];
    let id=`radio_button${props.index}`;
    let url = props.data['name'].toLowerCase()?.split(" ").join("_");
    if(url[url.length-1] === '_') {
        url = url.slice(0, -1);
    }
    let radio_default_value = props.URL_PARAMS.get(url) || "false";

    if(typeof(props.data['content'])===undefined){
        return <div></div>
    }

    for(let y=0; y<props.data['content'].length; y++){
        content.push(
            <div className="radio-button " key={y+1}>
                <input type="radio" className="radio-input" id={`radio-${props.data['content'][y]}`} name={id} value={props.data['content'][y]} defaultChecked={radio_default_value === props.data['content'][y]} required={props.data['required']} />
                <label htmlFor={`radio-${props.data['content'][y]}`}> {props.data['content'][y]} </label>
            </div>
        )
    }

    return(
        <div className="input-section" key={props.index}>
            <div className="input-nav multiple field-label">
                <label>
                    {props.data['name']}

                    { props.data['required'] && (
                        <span className="required" style={{ color: props.color }}> *</span>
                    )}
                </label>
                <div id={id}>
                    {content}
                </div>
            </div>
        </div>
    )

});

export default RadioButton;
